var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55078 7.30005C9.55078 8.54268 8.54341 9.55005 7.30078 9.55005C6.05815 9.55005 5.05078 8.54268 5.05078 7.30005C5.05078 6.05741 6.05815 5.05005 7.30078 5.05005C8.54341 5.05005 9.55078 6.05741 9.55078 7.30005Z",
    stroke: "#00B7FE",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43166 14.9443C8.12809 15.2366 7.72237 15.4 7.30018 15.4C6.8779 15.4 6.47218 15.2366 6.16861 14.9443C3.38887 12.2507 -0.336329 9.24176 1.48034 4.87336C2.46259 2.51139 4.82045 1 7.30018 1C9.77986 1 12.1377 2.5114 13.1199 4.87336C14.9343 9.23627 11.2182 12.26 8.43166 14.9443Z",
    stroke: "#00B7FE",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6984 17.2C12.6984 18.1941 10.2808 19 7.29844 19C4.3161 19 1.89844 18.1941 1.89844 17.2",
    stroke: "#00B7FE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.d64afeb3b73422978257b23818d614cb.svg";
export { ForwardRef as ReactComponent };